import { Typography, TypographyProps } from '@mui/material';

import { uiTypographySx, type CustomTypographyVariant } from '../config';

import type { SxProps, Theme } from '@mui/material/styles';

type Props = Omit<TypographyProps, 'variant'> & {
	variant?: CustomTypographyVariant;
	component?: React.ElementType;
};

export default function CustomTypography({ variant = 'bodyS', sx, component = 'span', ...props }: Props) {
	let additionalSx: SxProps<Theme>[] = [];
	if (Array.isArray(sx)) {
		additionalSx = sx as SxProps<Theme>[];
	} else if (sx) {
		additionalSx = [sx as SxProps<Theme>];
	}

	const sxArray: SxProps<Theme>[] = [uiTypographySx[variant], ...additionalSx];

	return <Typography {...props} component={component} sx={sxArray as SxProps<Theme>} />;
}
